import React, { useEffect, useRef, useState } from "react";
import vAdminformat from "../../adminFormat";


import config from '../../config';
import axios from "axios";
import { headers } from "../../token";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import validateError from "../../ValidateError";
import { useReactToPrint } from 'react-to-print';
import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";
import STLViewer from "../Canvas/STLViewer";
import AddCommentToScan from "./AddCommentToScan";
import UpdateJobs from "./JobUpdate";
import JobLiveUpdate from "./JobLiveUpdate";
import SimpleSTLViewer from "../Canvas/SimpleStlViews";
import AddLiveJobComment from "./AddLiveJobComment";
import STLViewerQuot from "../Canvas/SimpleStlViews";
import QRCode from "react-qr-code";
import getFileExtension from "../getFileExtension";

const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const ScanPointDesk = ({ username, jobID, CloseModalScanPoint }) => {

    const [loading, setLoading] = useState(false);
    const [attachOrder, setAttachOrder] = useState(jobID ? false : true);
    //const [attachOrder, setAttachOrder] = useState(false)
    const [OrderList, setOrderList] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [temporaryOrder, setTemporaryOrder] = useState(jobID ? jobID : []);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [statusQuot, setStatusQuot] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    const [filterBy, setFilterBy] = useState("ord_ID");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState("");
    const [order, setOrder] = useState([]);
    const [fileURL, setFileURL] = useState(null);
    const [isComment, setIsComment] = useState(false);
    const [isModifiyComment, setIsModifyComment] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [showPrintableDiv, setShowPrintableDiv] = useState(false);
    const [currentJob, setCurrentJob] = useState(null);
    const [direction, setDirection] = useState(""); //Animation address
    const [ItemFilter, setItemFilter] = useState(0);
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: '1900-01-01',
        to: '2100-12-31',
    });

    const navigate = useNavigate();
    const goToOrders = () => {
        navigate('/orders'); // Navigate to the "/Orders" route

    };

    const [productList, setProductList] = useState([]);
    const [modalItem, setModalItem] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [invoiceStatus, setInvoiceStatus] = useState("DRAFT");
    const statusOptions = [
        { label: "Draft", value: "DRAFT", color: "#ffc107" },
        { label: "Submitted", value: "SUBMITTED", color: "#17a2b8" },
        { label: "Authorised", value: "AUTHORISED", color: "#28a745" },
    ];

    useEffect(() => {

        FilterOrder();

    }, [filterBy, filterStatus, filterValue]);



    useEffect(() => {
        const getJobs = async () => {
            try {
                const response = await axios.get(`${server_backend}/Jobs/manual/list`, headers);
                console.log(response.data);
                if (response.data.RES_CODE === "00") {
                    setOrderList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getJobs();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {

        if (jobID) {

            const getJob = async () => {

                try {
                    const response = await axios.get(`${server_backend}/jobs/manual/select?id=${jobID}`, headers);

                    if (response.data.RES_CODE === "00") {
                        const data = response.data.RES_RESULT;
                        //Console.log ({data: data})
                        //Clean the modal and ensure that "items" is always present
                        //SetSeldtedorder (Data);
                        setOrder(data);
                        setFileURL(`${server_backend}/${data.files_path_file}`);
                        setSelectedOption('yes');
                        closeModalAttOrder(); //Close the Modal
                    }
                } catch (error) {
                    console.log(error);
                }

            }
            getJob()
        }
    }, [jobID]);

    useEffect(() => {
        const getProduct = async () => {
            try {
                const response = await axios.get(`${server_backend}/Products/list`, headers);

                if (response.data.RES_CODE === "00") {

                    const productsWithSelection = response.data.RES_RESULT.map(product => ({
                        ...product,
                        isSelected: true,
                    }));

                    setProductList(productsWithSelection);
                    setSelectedProducts(productsWithSelection); //inicialize selected products

                }
            } catch (error) {
                console.log(error);
            }
        };
        getProduct();
    }, []);

    useEffect(() => {
        const loadImage = async () => {
            try {
                const image = await SimpleSTLViewerToImage(fileURL);

                setImageURL(image);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        if (fileURL) {
            loadImage();
        }
    }, [fileURL]);


    const handleFormChange = (newStatus) => {
        if (newStatus > order.status_common) {
            setDirection("slide-left");
        } else {
            setDirection("slide-right");
        }

        setTimeout(() => {

            setDirection("");
        }, 500);
    };

    const showModalAttOrder = () => {
        setAttachOrder(true)
    }

    const closeModalAttOrder = () => {

        if (temporaryOrder) {
            setAttachOrder(false)
        } else {
            Swal.fire({
                icon: 'error',
                title: "You must select an order to proceed with generating the invoice.",
                showConfirmButton: false,
                timer: 2000
            });
        }

    }

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterOrder(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    };

    const FilterOrder = async () => {
        /*  console.log({ filterValue: filterValue, filterStatus: filterStatus, filterBy }) */

        try {
            const response = await axios.get(`${server_backend}/jobs/manual/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}&startDate=${selectedDayRange.from}&endDate=${selectedDayRange.to}`, headers);
            setOrderList(response.data.RES_RESULT);

        } catch (error) {
            console.log(error);
        }
    };

    const confirmOrderSelect = async () => {

        try {
            const response = await axios.post(`${server_backend}/jobs/manual/scan_point`, {
                id: temporaryOrder,
                point: 0
            }, headers);


        } catch (error) {
            console.log(error);
        }

        if (temporaryOrder) {
            try {
                const response = await axios.get(`${server_backend}/jobs/manual/select?id=${temporaryOrder}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;
                    console.log({ data: data })
                    //Clean the modal and ensure that "items" is always present
                    //SetSeldtedorder (Data);






                    setOrder(data)
                    setFileURL(`${server_backend}/${data.files_path_file}`);
                    setSelectedOption('yes');
                    closeModalAttOrder(); //Close the Modal






                }
            } catch (error) {
                console.log(error);
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: "You must select an order to proceed with generating the invoice.",
                showConfirmButton: false,
                timer: 2000
            });
        }
    };


    const getJob = async () => {

        try {
            const response = await axios.get(`${server_backend}/jobs/manual/select?id=${temporaryOrder}`, headers);

            if (response.data.RES_CODE === "00") {
                const data = response.data.RES_RESULT;
                //console.log ({data: data});
                //Clean the modal and ensure that "items" is always present
                //SetSeldtedorder (Data);






                setOrder(data)
                setFileURL(`${server_backend}/${data.files_path_file}`);
                setSelectedOption('yes');
                closeModalAttOrder(); //Close the Modal






            }
        } catch (error) {
            console.log(error);
        }

    }

    const handleOrderSelect = (Order) => {
        setTemporaryOrder(Order);
    };

    const CloseAddCommentModal = () => {
        setIsComment(false)
    }

    const showAddCommentModal = () => {
        setIsComment(true)
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const componentRef = useRef();


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Material Information",
        onAfterPrint: () => setShowPrintableDiv(false),

    });


    const [imageURL, setImageURL] = useState(null);



    const handleUpdate = async (estID) => {

        setLoading(true);

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/jobs/manual/scan_point`, {
                        id: temporaryOrder,
                        point: estID
                    }, headers);
                    //Console.log(response.data);






                    if (response.data.RES_CODE === "00") {
                        /*  Swal.fire({
                                icon: 'success',
                                title: 'Updated Successfully',
                                showConfirmButton: false,
                                timer: 2000
                            }); */

                        handleFormChange(estID);

                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error updating Order',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const responseData = error.response.data.RES_MESSAGE;
                    //Console.log(error)






                    Swal.fire({
                        icon: 'error',
                        title: responseData,
                        showConfirmButton: false,
                        timer: 3000
                    });
                } finally {
                    getJob();
                    setLoading(false);
                }
            }
        }
        )
    };

    const changePriority = async (priority) => {

        if (priority === order.priority) {
            return;
        }

        try {

            const response = await axios.post(`${server_backend}/jobs/manual/priority`, {
                id: temporaryOrder,
                priority: priority
            }, headers);
            //Console.log(response.data);






            if (response.data.RES_CODE === "00") {
                /* Swal.fire({
                    icon: 'success',
                    title: 'Updated Successfully',
                    showConfirmButton: false,
                    timer: 2000
                }); */

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error updating Order',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const responseData = error.response.data.RES_MESSAGE;
            //Console.log(error)






            Swal.fire({
                icon: 'error',
                title: responseData,
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            getJob()
        }

    };

    const handleSelectQuantity = async (job, quantity) => {
        //setCurrentJobQty(quantity);
        //console.log({ jobID: job.job_ID, quantity: quantity, confirm: job.sp1_pass, point: order.point });







        try {

            const response = await axios.post(`${server_backend}/jobs/manual/point`, {
                id: job.job_ID,
                ord_id: order.ord_ID,
                point: order.point,
                qty: quantity,
                confirm: order.point === 1 ? job.sp1_pass : (order.point === 2 ? job.sp2_pass : (order.point === 3 ? job.sp3_pass : (order.point === 4 ? job.sp4_pass : 0)))
            }, headers);

            if (response.data.RES_CODE === "00") {
                /*  Swal.fire({
                    icon: 'success',
                    title: 'Updated Successfully',
                    showConfirmButton: false,
                    timer: 2000
                }); */

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error updating Order',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const responseData = error.response.data.RES_MESSAGE;
            //Console.log(error)






            Swal.fire({
                icon: 'error',
                title: responseData,
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            getJob()
        }

    };

    const handleChangePass = async (job, confirm) => {

        try {

            if (order.point === 1) {
                if (job.sp1_pass === confirm) {
                    return;
                }
            } else if (order.point === 2) {
                if (job.sp2_pass === confirm) {
                    return;
                }
            } else if (order.point === 3) {
                if (job.sp3_pass === confirm) {
                    return;
                }
            } else if (order.point === 4) {
                if (job.sp4_pass === confirm) {
                    return;
                }
            }

            const response = await axios.post(`${server_backend}/jobs/manual/point`, {
                id: job.job_ID,
                ord_id: order.ord_ID,
                point: order.point,
                qty: order.point === 1 ? job.sp1_qty : (order.point === 2 ? job.sp2_qty : (order.point === 3 ? job.sp3_qty : (order.point === 4 ? job.sp4_qty : 0))),
                confirm: confirm
            }, headers);

            if (response.data.RES_CODE === "00") {
                /* Swal.fire({
                    icon: 'success',
                    title: 'Updated Successfully',
                    showConfirmButton: false,
                    timer: 2000
                }); */

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error updating Order',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const responseData = error.response.data.RES_MESSAGE;
            //Console.log(error)






            Swal.fire({
                icon: 'error',
                title: responseData,
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            getJob()
        }
    }

    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                if (response.data.RES_CODE === "00") {
                    //Console.log(response.data);






                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusJob();
    }, []);


    const createInvoiceXero = async () => {


        const Products = [
            {
                comment: order.materials_comment || "ITEM001",
                name: order.materials_name,
                qty: order.qty,
                price: order.price,
                discount: order.discount || 0
            },
            ...selectedProducts
        ];

        //console.log({ selectedProducts: Products });

        try {
            const lineItems = Products.map((product) => ({
                itemCode: product.comment || "ITEM001",
                description: product.name,
                quantity: product.qty,
                unitAmount: product.price,
                accountCode: '400',
                TaxType: "TAX001",
                unitTaxAmount: (product.price * 0.20) / product.qty,
                discountRate: product.discount || 0
            }));

            const currentDate = new Date();
            const currentDateInMillis = currentDate.getTime();

            const invoiceData = {
                type: "ACCREC",
                contact: {
                    name: `${order.fullname}`,
                    accountNumber: `${order.fullname}`,
                    emailAddress: `${order.email || "example@gmail.com"}`
                },
                CurrencyCode: "GBP",
                date: `/Date(${currentDateInMillis}+0000)/`,
                dueDate: `/Date(${currentDateInMillis + 7 * 24 * 60 * 60 * 1000}+0000)/`,
                dateString: currentDate.toISOString(),
                dueDateString: new Date(currentDate.setDate(currentDate.getDate() + 7)).toISOString(),
                lineAmountTypes: "Exclusive",
                status: invoiceStatus,
                lineItems: lineItems
            };

            const response = await axios.post(`${server_backend}/api/xero/invoice`, { invoiceData }, headers);

            closeModalItem()

            Swal.fire({
                icon: 'success',
                title: 'Invoice sent successfully',
                showConfirmButton: false,
                timer: 1000,
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'An unexpected error has occurred, please try again later.',
                showConfirmButton: false,
                timer: 2000,
            });
        }
    };

    const openModalItem = () => {
        setModalItem(true);
    }

    const closeModalItem = () => {
        setModalItem(false);
    }

    const handleCheckboxChange = (product) => {
        setProductList((prevList) =>
            prevList.map((item) =>
                item.pto_ID === product.pto_ID
                    ? { ...item, isSelected: !item.isSelected }
                    : item
            )
        );

        setSelectedProducts((prevSelected) => {
            const isAlreadySelected = prevSelected.some((p) => p.pto_ID === product.pto_ID);
            if (isAlreadySelected) {
                return prevSelected.filter((p) => p.pto_ID !== product.pto_ID);
            } else {
                return [...prevSelected, { ...product }];
            }
        });
    };

    const handleQuantityChange = (id, newQty) => {
        setProductList((prevList) =>
            prevList.map((item) =>
                item.pto_ID === id ? { ...item, qty: newQty } : item
            )
        );

        setSelectedProducts((prevSelected) =>
            prevSelected.map((product) =>
                product.pto_ID === id ? { ...product, qty: newQty } : product
            )
        );
    };

    const handlePriceChange = (id, newPrice) => {
        setProductList((prevList) =>
            prevList.map((item) =>
                item.pto_ID === id ? { ...item, price: newPrice } : item
            )
        );

        setSelectedProducts((prevSelected) =>
            prevSelected.map((product) =>
                product.pto_ID === id ? { ...product, price: newPrice } : product
            )
        );
    };

    return (

        <div className={`${jobID ? "" : "page-content"}`} data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "hidden" }}>
            {/* <div className={`${OrderID ? "" : "page-content"}`} data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "hidden" }}></div> */}
            <div className="">
                {isUpdating ? (
                    <JobLiveUpdate CloseViewJob={CloseModalUpdate} JobID={currentJob} getJobs={getJob} />
                ) : (
                    <div
                        className={`form-container ${direction}`}
                        style={{ position: "relative", overflow: "hidden" }}
                    >
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row gx-lg-5">
                                            <div className="col-xl-4 col-md-8 mx-auto" style={{ position: "relative" }}>
                                                <div className="d-flex align-items-start gap-2">
                                                    {order.point !== 1 && (
                                                        <button
                                                            className="btn btn-warning d-flex align-items-center"
                                                            onClick={() => {
                                                                if (order.point === 5) {
                                                                    handleUpdate(4);
                                                                }
                                                                if (order.point === 4) {
                                                                    handleUpdate(3);
                                                                } else if (order.point === 3) {
                                                                    handleUpdate(2);
                                                                } else if (order.point === 2) {
                                                                    handleUpdate(1);
                                                                }
                                                            }}
                                                        >
                                                            <i className="ri-arrow-go-back-line me-2"></i>
                                                            Send Back
                                                        </button>
                                                    )}

                                                    <Link
                                                        type="button"

                                                        onClick={() => {
                                                            showModalAttOrder()
                                                        }}
                                                        data-toggle="tooltip" data-placement="top" title=" Scan Point"
                                                        className="btn btn-secondary text-white d-flex align-items-center"
                                                    >
                                                        <i className="ri-qr-scan-2-line"></i>
                                                    </Link>
                                                </div>

                                                <div className="product-img-slider sticky-side-div">
                                                    <div className="swiper-slide">
                                                        <div className="text-muted">{order.file_name}</div>
                                                        <div
                                                            className="col-12"
                                                            style={{
                                                                minHeight: "60vh",
                                                                height: "60vh",
                                                                border: "1px solid #dcdcdc",
                                                                display: "flex",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            {fileURL && (getFileExtension(fileURL) === "stl" || getFileExtension(fileURL) === "obj") ? (
                                                                <STLViewerQuot
                                                                    url={fileURL}
                                                                    currentColor={order.materials_color}
                                                                    mystl={true}
                                                                />
                                                            ) : (
                                                                fileURL && (
                                                                    <img src={fileURL} alt="Selected File" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-8">
                                                <div className="mt-xl-0 mt-5">
                                                    <div className="d-flex">
                                                        <div className="flex-grow-1">
                                                            <h4>{order.fullname}</h4>

                                                            <div className="hstack gap-3 flex-wrap">
                                                                <p className="mb-0 text-muted">{order.job_number}</p>
                                                                <div className="vr"></div>
                                                                <div className="text-muted">
                                                                    Reprint Qty:
                                                                    <span className="text-body fw-medium"> {order.reprint}</span>
                                                                </div>
                                                                <div className="vr"></div>
                                                                <div className="text-muted">
                                                                    <span
                                                                        className={`badge ${order.isMould ? "bg-primary" : "bg-secondary"} text-dark d-flex align-items-center gap-1 border text-white`}
                                                                        style={{ fontSize: "0.75rem" }}
                                                                        title={order.isMould ? "Mould" : "Job (STL)"}
                                                                    >
                                                                        <i className={`ri ${order.isMould ? 'ri-coin-line' : 'bx bx-cube'} fs-6`}></i>
                                                                        {order.isMould ? "Mould" : "Job (STL)"}
                                                                    </span>
                                                                </div>
                                                                <div className="vr"></div>
                                                                <div className="text-muted">
                                                                    <span className="text-body fw-medium">{vAdminformat.FormatDate(order.date_created)}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <center>
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        {order.barcode && (
                                                                            <>
                                                                                <QRCode
                                                                                    size={25}
                                                                                    style={{ height: "auto", width: "15vh" }}
                                                                                    value={`${server_frontend}/jobs/qr-single-job?qr=${order.barcode}`}
                                                                                    viewBox="0 0 256 256"
                                                                                />
                                                                                <label class="form-label">Single QR</label>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-6">
                                                                        {order.colle_id > 0 ? (
                                                                            <div style={{ marginRight: "15px", textAlign: "center" }}>

                                                                                <QRCode
                                                                                    size={25}
                                                                                    style={{ height: "auto", width: "15vh" }}
                                                                                    value={`${server_frontend}/jobs/collective/qr-group?group=${order.colle_id}`}
                                                                                    viewBox="0 0 256 256"
                                                                                /> <br />
                                                                                <label className="form-label">Collective QR</label>
                                                                            </div>
                                                                        ) : (
                                                                            <div style={{ marginRight: "15px", textAlign: "center" }}>
                                                                                <div
                                                                                    style={{
                                                                                        height: "15vh",
                                                                                        width: "15vh",
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        border: "2px solid #ccc",
                                                                                        fontSize: "10px",
                                                                                        color: "#666",
                                                                                        textAlign: "center",
                                                                                        padding: "5px",
                                                                                    }}
                                                                                >
                                                                                    No assigned <br /> group
                                                                                </div>
                                                                                <label style={{ marginRight: "21px" }} className="form-label ">Collective QR</label>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>



                                                        </center>

                                                        <div className="flex-shrink-0">
                                                            <div>
                                                                <div className="avatar-sm flex-shrink-0">
                                                                    <span
                                                                        data-bs-toggle="dropdown"
                                                                        aria-haspopup="true"
                                                                        aria-expanded="false"
                                                                        className={`avatar-title ${order.priority === 1 ? "bg-success" : (order.priority === 2 ? "bg-warning" : (order.priority === 3 ? "bg-danger opacity-50" : "bg-danger"))}  fs-2`}
                                                                        role="button"
                                                                        style={{ borderRadius: "5px" }}
                                                                    >
                                                                        <i data-feather="users" className="text-light"></i>
                                                                        {order.status_common}
                                                                    </span>
                                                                    <div className="dropdown-menu p-2 shadow rounded border-0">
                                                                        <button
                                                                            className="dropdown-item bg-success text-white mb-2 rounded-lg py-2  px-3 text-center"
                                                                            style={{ transition: "all 0.3s ease", borderRadius: "10px" }}
                                                                            type="button"
                                                                            onClick={() => changePriority(1)}>
                                                                            Normal
                                                                        </button>
                                                                        <button
                                                                            className="dropdown-item bg-warning text-white mb-2 rounded-lg py-2 px-3 text-center"
                                                                            type="button"
                                                                            style={{ transition: "all 0.3s ease", borderRadius: "10px" }}
                                                                            onClick={() => changePriority(2)}>
                                                                            Important
                                                                        </button>
                                                                        <button

                                                                            className="dropdown-item bg-danger opacity-75 text-white mb-2 rounded-lg py-2 px-3 text-center"
                                                                            type="button"
                                                                            style={{ transition: "all 0.3s ease", borderRadius: "10px" }}

                                                                            onClick={() => changePriority(3)}>
                                                                            Moderate
                                                                        </button>
                                                                        <button
                                                                            className="dropdown-item bg-danger text-white rounded-lg py-2 px-3 text-center"
                                                                            type="button"
                                                                            style={{ transition: "all 0.3s ease", borderRadius: "10px" }} onClick={() => changePriority(4)}>
                                                                            Urgent
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="product-content mt-5">
                                                        <h5 className="fs-14 mb-3">
                                                            {order.point === 1
                                                                ? "Correct number of waxes delivered?"
                                                                : (order.point === 2
                                                                    ? "All items successfully built onto their correct trees?"
                                                                    : (order.point === 3
                                                                        ? "All items successfully completed?"
                                                                        : (order.point === 4
                                                                            ? "Ready to finalize Production Sheet and weight?"
                                                                            : "")))}
                                                        </h5>
                                                        <nav>
                                                            <ul
                                                                className="nav nav-tabs nav-tabs-custom nav-success"
                                                                id="nav-tab"
                                                                role="tablist"
                                                            >

                                                            </ul>
                                                        </nav>

                                                        <div
                                                            className="tab-content border border-top-0 p-4"
                                                            id="nav-tabContent"
                                                        > <center><p>{order.comment}</p></center>
                                                            <div
                                                                className="tab-pane fade show active"
                                                                id="nav-speci"
                                                                role="tabpanel"
                                                                aria-labelledby="nav-speci-tab"
                                                            >
                                                                <div className="table-responsive">

                                                                    <table className="table mb-0" style={{ height: "40vh", maxHeight: "40vh", overflowY: "auto" }}>

                                                                        {order.point > 4 ? (
                                                                            <>
                                                                                <tbody>

                                                                                    <tr>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6 className="p-0">Correct number of waxes delivered?</h6>
                                                                                        </td>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6>{order.qty}</h6>
                                                                                        </td>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6> {order.sp1_qty}</h6>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button
                                                                                                type="button"
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions






                                                                                                className={`btn ${order.sp1_pass === 1 ? "btn-success" : "btn-outline-success"} rounded-circle btn-icon waves-effect waves-light`}

                                                                                            >Y</button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button type="button"
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions






                                                                                                className={`btn ${order.sp1_pass === 0 ? "btn-danger" : "btn-outline-danger"} rounded-circle btn-icon waves-effect waves-light`}

                                                                                            >N</button>
                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            <Link
                                                                                                style={{ pointerEvents: "none" }}>

                                                                                                <i
                                                                                                    className={`${order.sp1_pass === 1
                                                                                                        ? "ri-checkbox-circle-line text-success"
                                                                                                        : "ri-settings-5-fill text-black"
                                                                                                        }`}
                                                                                                    style={{ fontSize: "25px", verticalAlign: "middle" }}
                                                                                                ></i>

                                                                                            </Link>
                                                                                        </td>
                                                                                    </tr>

                                                                                    <tr>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6 className="p-0">All items successfully built onto their correct trees?</h6>
                                                                                        </td>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6>{order.qty}</h6>
                                                                                        </td>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6> {order.sp2_qty}</h6>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button
                                                                                                type="button"
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions






                                                                                                className={`btn ${order.sp2_pass === 1 ? "btn-success" : "btn-outline-success"} rounded-circle btn-icon waves-effect waves-light`}

                                                                                            >Y</button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button type="button"
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions






                                                                                                className={`btn ${order.sp2_pass === 0 ? "btn-danger" : "btn-outline-danger"} rounded-circle btn-icon waves-effect waves-light`}

                                                                                            >N</button>
                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            <Link style={{ pointerEvents: "none" }}>

                                                                                                <i
                                                                                                    className={`${order.sp2_pass === 1
                                                                                                        ? "ri-checkbox-circle-line text-success"
                                                                                                        : "ri-settings-5-fill text-black"
                                                                                                        }`}
                                                                                                    style={{ fontSize: "25px", verticalAlign: "middle" }}
                                                                                                ></i>

                                                                                            </Link>
                                                                                        </td>
                                                                                    </tr>

                                                                                    <tr>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6 className="p-0">All items successfully completed?</h6>
                                                                                        </td>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6>{order.qty}</h6>
                                                                                        </td>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6> {order.sp3_qty}</h6>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button
                                                                                                type="button"
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions






                                                                                                className={`btn ${order.sp3_pass === 1 ? "btn-success" : "btn-outline-success"} rounded-circle btn-icon waves-effect waves-light`}

                                                                                            >Y</button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button type="button"
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions






                                                                                                className={`btn ${order.sp3_pass === 0 ? "btn-danger" : "btn-outline-danger"} rounded-circle btn-icon waves-effect waves-light`}

                                                                                            >N</button>
                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            <Link style={{ pointerEvents: "none" }}>

                                                                                                <i
                                                                                                    className={`${order.sp3_pass === 1
                                                                                                        ? "ri-checkbox-circle-line text-success"
                                                                                                        : "ri-settings-5-fill text-black"
                                                                                                        }`}
                                                                                                    style={{ fontSize: "25px", verticalAlign: "middle" }}
                                                                                                ></i>

                                                                                            </Link>
                                                                                        </td>
                                                                                    </tr>

                                                                                    <tr>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6 className="p-0">Ready to finalize Production Sheet and weight?</h6>
                                                                                        </td>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6>{order.qty}</h6>
                                                                                        </td>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6> {order.sp4_qty}</h6>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button
                                                                                                type="button"
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions






                                                                                                className={`btn ${order.sp4_pass === 1 ? "btn-success" : "btn-outline-success"} rounded-circle btn-icon waves-effect waves-light`}

                                                                                            >Y</button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button type="button"
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions






                                                                                                className={`btn ${order.sp4_pass === 0 ? "btn-danger" : "btn-outline-danger"} rounded-circle btn-icon waves-effect waves-light`}

                                                                                            >N</button>
                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            <Link style={{ pointerEvents: "none" }}>

                                                                                                <i
                                                                                                    className={`${order.sp4_pass === 1
                                                                                                        ? "ri-checkbox-circle-line text-success"
                                                                                                        : "ri-settings-5-fill text-black"
                                                                                                        }`}
                                                                                                    style={{ fontSize: "25px", verticalAlign: "middle" }}
                                                                                                ></i>

                                                                                            </Link>
                                                                                        </td>
                                                                                    </tr>

                                                                                </tbody>
                                                                            </>

                                                                        ) : (
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                        <h6>{order.comment}</h6>
                                                                                    </td>
                                                                                    <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                        <h6>{order.qty}</h6>
                                                                                    </td>
                                                                                    <td className="font-weight-bold">
                                                                                        <div className="dropdown">
                                                                                            <button
                                                                                                className="btn btn-light dropdown-toggle"
                                                                                                type="button"
                                                                                                id={`dropdownMenuButton-${order.point === 1 ? order.sp1_qty : (order.point === 2 ? order.sp2_qty : (order.point === 3 ? order.sp3_qty : (order.point === 4 ? order.sp4_qty : "")))}`}
                                                                                                data-bs-toggle="dropdown"
                                                                                                aria-expanded="false"
                                                                                            >
                                                                                                {order.point === 1 ? order.sp1_qty : (order.point === 2 ? order.sp2_qty : (order.point === 3 ? order.sp3_qty : (order.point === 4 ? order.sp4_qty : "")))}
                                                                                            </button>
                                                                                            <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${order.point === 1 ? order.sp1_qty : (order.point === 2 ? order.sp2_qty : (order.point === 3 ? order.sp3_qty : (order.point === 4 ? order.sp4_qty : "")))}`}>
                                                                                                {Array.from({ length: order.qty + 1 }, (_, i) => (
                                                                                                    <li key={i}>
                                                                                                        <button className="dropdown-item" onClick={() => handleSelectQuantity(order, i)}>
                                                                                                            {i}
                                                                                                        </button>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <button
                                                                                            type="button"

                                                                                            className={`btn ${order.point === 1 ? (order.sp1_pass === 1 ? "btn-success" : "btn-outline-success") : (order.point === 2 ? (order.sp2_pass === 1 ? "btn-success" : "btn-outline-success") : (order.point === 3 ? (order.sp3_pass === 1 ? "btn-success" : "btn-outline-success") : (order.point === 4 ? (order.sp4_pass === 1 ? "btn-success" : "btn-outline-success") : "")))} rounded-circle btn-icon waves-effect waves-light`}
                                                                                            onClick={() => handleChangePass(order, 1)}
                                                                                        >Y</button>
                                                                                    </td>
                                                                                    <td>
                                                                                        <button type="button"

                                                                                            className={`btn ${order.point === 1 ? (order.sp1_pass === 0 ? "btn-danger" : "btn-outline-danger") : (order.point === 2 ? (order.sp2_pass === 0 ? "btn-danger" : "btn-outline-danger") : (order.point === 3 ? (order.sp3_pass === 0 ? "btn-danger" : "btn-outline-danger") : (order.point === 4 ? (order.sp4_pass === 0 ? "btn-danger" : "btn-outline-danger") : "")))} rounded-circle btn-icon waves-effect waves-light`}
                                                                                            onClick={() => handleChangePass(order, 0)}
                                                                                        >N</button>
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                        <Link>

                                                                                            <i
                                                                                                className={`${order.point === 5
                                                                                                    ? "ri-checkbox-circle-line text-success"
                                                                                                    : "ri-settings-5-fill text-black"
                                                                                                    }`}
                                                                                                style={{ fontSize: "25px", verticalAlign: "middle" }}
                                                                                            ></i>

                                                                                        </Link>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        )}



                                                                    </table>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="hstack gap-2 justify-content-end d-print-none mt-4">

                                                        <button className="btn btn-warning w-25" style={{ marginRight: '5px' }} onClick={showAddCommentModal}>
                                                            Reprint
                                                        </button>

                                                        {order.point === 5 && (
                                                            <button className="btn btn-secondary w-25" style={{ marginRight: '5px' }} onClick={openModalItem}>
                                                                Send To Xero
                                                            </button>
                                                        )}

                                                        {
                                                            order.point !== 5 && (
                                                                <button className={`btn ${order.point === 4 ? "btn-success" : "btn-secondary"} w-25`} onClick={() => {

                                                                    if (order.point === 1) {
                                                                        handleUpdate(2)
                                                                    } else if (order.point === 2) {
                                                                        handleUpdate(3)
                                                                    } else if (order.point === 3) {
                                                                        handleUpdate(4)
                                                                    } else if (order.point === 4) {
                                                                        handleUpdate(5)

                                                                    }

                                                                }}>
                                                                    {order.point === 1 ? "SP2" : (order.point === 2 ? "SP3" : (order.point === 3 ? "Confirm QC" : (order.point === 4 ? "Complete" : "SP3")))}
                                                                </button>
                                                            )
                                                        }


                                                    </div>
                                                    {/*end card body */}
                                                </div>
                                            </div>
                                            {/*end col */}
                                        </div>
                                        {/*end row */}
                                    </div>
                                    {/*end card body */}
                                </div>
                                {/*end card */}
                            </div>
                            {/*end col */}
                        </div>
                        {/*end row */}
                    </div>


                )}
            </div>
            <div
                className={`modal fade ${attachOrder ? "show" : ""}`}
                style={{ display: attachOrder ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <center>
                                <h5 className="modal-title" id="myExtraLargeModalLabel">Select Existing Job</h5>
                            </center>
                            <Link className="btn-close" to={"/orders"} aria-label="Close"></Link>
                        </div>
                        <div className="modal-body" style={{ minHeight: "80vh" }}>
                            <div>
                                <div className="mb-3" ref={dropdownRef}>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-4">
                                                <div className="input-light">
                                                    <p className='p-0 m-0 text-muted'>Find by</p>
                                                    <select
                                                        className="form-control custom-select-style"
                                                        name="choices-single-default"
                                                        value={filterBy}
                                                        onChange={handleFilterByChange}
                                                    >
                                                        <option value="fullname">Filter by</option>
                                                        <option value="job_number">Job Number</option>
                                                        <option value="fullname">Customer name</option>
                                                        <option value="comment">Description</option>
                                                        <option value="materials_name">Material</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-4">
                                                <div className="input-light">
                                                    <p className='p-0 m-0 text-muted'>Filter Status</p>
                                                    <select
                                                        className="form-control custom-select-style"
                                                        name="choices-single-default"
                                                        id="idFilterStatus"
                                                        onChange={handleFilterStatusChange}
                                                    >
                                                        <option value={0}>Filter status</option>
                                                        {statusQuot.map((status) => (
                                                            <option key={status.est_ID} value={status.est_ID}>{status.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-4">
                                                <p className='p-0 m-0 text-muted'>Item</p>
                                                <div className='mb-3'>
                                                    <select
                                                        className="form-control custom-select-style"
                                                        name="choices-single-default"
                                                        value={ItemFilter}
                                                        onChange={(e) => setItemFilter(Number(e.target.value))}
                                                    >
                                                        <option value={0}>All</option>
                                                        <option value={1}>STL</option>
                                                        <option value={2}>Mould</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <p className='p-0 m-0 text-muted'>Search For</p>
                                                <div className='mb-3'>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="select-existing-Order"
                                                        onKeyUp={handleFilterValueChange}
                                                        onFocus={() => setShowDropdown(true)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <h5 className="mb-3">Print Items Overview</h5>


                                    <button
                                        key="header"
                                        type="button"
                                        className="d-flex text-start justify-content-between w-100 mb-2"
                                        style={{
                                            padding: '10px 15px',
                                            borderRadius: '6px',
                                            border: '0px solid #dcdcdc',
                                            backgroundColor: '#f0f0f0',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        <div className="col-1 text-center"></div>
                                        <div className="col-1"><span>No.</span></div>
                                        <div className="col-md-4 text-center"><span>Full Name</span></div>
                                        <div className="col-md-3 text-center"><span>Status</span></div>
                                        <div className="col-md-3 text-center"><span>Material</span></div>
                                    </button>

                                    <div
                                        className="mt-2"
                                        style={{
                                            maxHeight: '250px',
                                            overflowY: 'auto',
                                            padding: "15px",
                                            border: '1px solid #dcdcdc',
                                            backgroundColor: '#fff'
                                        }}
                                    >
                                        {(ItemFilter === 1 || ItemFilter === 0) ?
                                            OrderList.filter(item => !item.isMould).length > 0 && (
                                                <>
                                                    <div className="text-muted mb-2">Jobs (STL Files)</div>
                                                    {OrderList.filter(item => !item.isMould).map((Order) => (
                                                        <button
                                                            key={Order.job_ID}
                                                            type='button'
                                                            className={`d-flex align-items-center justify-content-center text-center w-100 mb-2 ${temporaryOrder === Order.job_ID ? 'bg-primary text-white shadow-sm' : ''}`}
                                                            style={{
                                                                padding: '10px 15px',
                                                                borderRadius: '6px',
                                                                border: '0px solid #dcdcdc',
                                                                backgroundColor: temporaryOrder === Order.job_ID ? '#007bff' : '#fff',
                                                                color: temporaryOrder === Order.job_ID ? '#fff' : '#333',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                                                            }}
                                                            onClick={() => handleOrderSelect(Order.job_ID)}
                                                        >

                                                            <i className={`fas bx bx-cube fs-24 fa-lg`} title={Order.isMould ? 'Mould' : 'Job (STL)'}></i>
                                                            <div className="col-1 d-flex justify-content-center align-items-center">
                                                                <span>{Order.job_number}</span>
                                                            </div>
                                                            <div className="col-md-4 d-flex justify-content-center align-items-center">
                                                                <span>{Order.fullname}</span>
                                                            </div>
                                                            <div className="col-md-3 d-flex justify-content-center align-items-center">
                                                                <span>{Order.status_name}</span>
                                                            </div>
                                                            <div className="col-md-3 d-flex justify-content-center align-items-center">
                                                                <span>{Order.materials_name}</span>
                                                            </div>
                                                        </button>
                                                    ))}
                                                </>
                                            ) : null}

                                        {/* Moulds */}
                                        {(ItemFilter === 2 || ItemFilter === 0) ?

                                            OrderList.filter(item => item.isMould).length > 0 && (
                                                <>
                                                    <div className="text-muted mt-4 mb-2">Moulds</div>
                                                    {OrderList.filter(item => item.isMould).map((Order) => (
                                                        <button
                                                            key={Order.job_ID}
                                                            type='button'
                                                            className={`d-flex align-items-center justify-content-center text-center w-100 mb-2 ${temporaryOrder === Order.job_ID ? 'bg-success text-white shadow-sm' : ''}`}
                                                            style={{
                                                                padding: '10px 15px',
                                                                borderRadius: '6px',
                                                                border: '0px solid #dcdcdc',
                                                                backgroundColor: temporaryOrder === Order.job_ID ? '#28a745' : '#fff',
                                                                color: temporaryOrder === Order.job_ID ? '#fff' : '#333',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                                                            }}
                                                            onClick={() => handleOrderSelect(Order.job_ID)}
                                                        >

                                                            <i className={`fas bx  ri-coin-line fs-24 fa-lg`} title={Order.isMould ? 'Mould' : 'Job (STL)'}></i>

                                                            <div className="col-1 d-flex justify-content-center align-items-center">
                                                                <span>{Order.job_number}</span>
                                                            </div>
                                                            <div className="col-md-4 d-flex justify-content-center align-items-center">
                                                                <span>{Order.fullname}</span>
                                                            </div>
                                                            <div className="col-md-3 d-flex justify-content-center align-items-center">
                                                                <span>{Order.status_name}</span>
                                                            </div>
                                                            <div className="col-md-3 d-flex justify-content-center align-items-center">
                                                                <span>{Order.materials_name}</span>
                                                            </div>
                                                        </button>
                                                    ))}
                                                </>
                                            ) : null}

                                        {OrderList.length === 0 && (
                                            <div className="text-center">No Orders found</div>
                                        )}
                                    </div>

                                </div>
                            </div>
                            <div className="d-flex justify-content-end">
                                <Link type="button" className="btn btn-danger" to="/orders" style={{ marginRight: "5px" }} >
                                    Discard
                                </Link>
                                <button type="button" className="btn btn-primary" onClick={confirmOrderSelect}>
                                    Select
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div
                className={`modal fade ${modalItem ? "show" : ""}`}
                style={{ display: modalItem ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog w-75" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white">
                            <h3 className="modal-title" id="addItemModalLabel">
                                <i className="fas fa-file-invoice"></i> Generate Invoice to Xero
                            </h3>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={closeModalItem}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="card border-0">
                                <div className="card-body">
                                    <h4 className="text-center text-secondary">Product Selection</h4>


                                    {/*Status Selection */}
                                    <div className="mb-4">
                                        <label className="form-label">Invoice Status in Xero</label>
                                        <select
                                            className="form-select"
                                            value={invoiceStatus}
                                            onChange={(e) => setInvoiceStatus(e.target.value)}
                                        >
                                            {statusOptions.map((status) => (
                                                <option
                                                    key={status.value}
                                                    value={status.value}

                                                >
                                                    {status.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-striped table-sm table-hover align-middle">
                                            <thead>
                                                <tr>
                                                    <th>Select</th>
                                                    <th>Name</th>
                                                    <th>Quantity</th>
                                                    <th>Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style={{ cursor: 'pointer' }}>
                                                    <td></td>
                                                    <td>{order.materials_name}</td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            min="1"
                                                            value={order.qty || 1}
                                                            onChange={(e) => handleQuantityChange(order.pto_ID, parseInt(e.target.value))}
                                                            disabled={!order.isSelected}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            min="0"
                                                            step="0.01"
                                                            value={order.price}
                                                            onChange={(e) => handlePriceChange(order.pto_ID, parseFloat(e.target.value))}
                                                            disabled={!order.isSelected}
                                                        />
                                                    </td>
                                                </tr>
                                                {productList.map((product) => (
                                                    <tr key={product.pto_ID} style={{ cursor: 'pointer' }}>
                                                        <td onClick={() => handleCheckboxChange(product)}>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={product.isSelected}
                                                                onChange={() => handleCheckboxChange(product)}
                                                            />
                                                        </td>
                                                        <td onClick={() => handleCheckboxChange(product)}>
                                                            <label style={{ cursor: 'pointer' }}>
                                                                {product.name}
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                min="1"
                                                                defaultValue={1}
                                                                value={product.qty}
                                                                onChange={(e) => handleQuantityChange(product.pto_ID, parseInt(e.target.value))}
                                                                disabled={!product.isSelected}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                min="0"
                                                                step="0.01"
                                                                value={product.price}
                                                                onChange={(e) => handlePriceChange(product.pto_ID, parseFloat(e.target.value))}
                                                                disabled={!product.isSelected}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={closeModalItem}
                            >
                                <i className="fas fa-times"></i> Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={createInvoiceXero}
                            >
                                <i className="fas fa-save"></i> Save Changes & Send to Xero
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            {/*end row*/}
            {isComment && (
                <AddLiveJobComment JobID={temporaryOrder} onClose={CloseAddCommentModal} isBegin={true} getJobs={getJob} Qty={order.qty} isScanPoint={true} />
            )}
        </div>
    )
}


export default ScanPointDesk